export default __webpack_public_path__ + "static/media/Imagen2.c3781daa.svg";